import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { img } from "../../constants/assets";
import { useBookDemo } from "../../context/BookDemoContext";
import LanguageSwitcher from "../LanguageSwitcher";

const navItems = [
  { labelKey: "nav.platform", to: "/technology" },
  { labelKey: "nav.solutions", to: "/solutions" },
  { labelKey: "nav.industries", to: "/industries" },
  { labelKey: "nav.api", to: "/developers" },
  { labelKey: "nav.partners", to: "/partners" },
  { labelKey: "nav.company", to: "/contact" },
];

function Navbar() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { openBookDemo } = useBookDemo();

  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const handleBookDemo = () => {
    closeMenu();
    openBookDemo();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light p-0">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={closeMenu}>
          <span>
            <img src={img("logo.svg")} alt="R4L Solutions" />
          </span>
        </Link>
        <button
          className="navbar-toggler ms-auto"
          type="button"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-controls="navbarSupportedContent"
          aria-expanded={isMenuOpen}
          aria-label={t("nav.toggleNav")}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse${isMenuOpen ? " show" : ""}`}
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
            {navItems.map((item) => (
              <li className="nav-item" key={item.labelKey}>
                {item.to.startsWith("/") ? (
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                    to={item.to}
                    onClick={closeMenu}
                  >
                    {t(item.labelKey)}
                  </NavLink>
                ) : (
                  <a className="nav-link" href={item.to} onClick={closeMenu}>
                    {t(item.labelKey)}
                  </a>
                )}
              </li>
            ))}
          </ul>
          <div className="d-flex gap-3 align-items-center navbar-actions">
            <LanguageSwitcher />
            <Link
              className="navbar-auth-link"
              to="/login"
              onClick={closeMenu}
            >
              {t("nav.login")}
            </Link>
            <button
              className="btn-cs btn-booking"
              type="button"
              onClick={handleBookDemo}
            >
              {t("nav.bookDemo")}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
